import { render } from "./InvitationListTab.vue?vue&type=template&id=b8f7936e&scoped=true&ts=true"
import script from "./InvitationListTab.vue?vue&type=script&lang=ts"
export * from "./InvitationListTab.vue?vue&type=script&lang=ts"

import "./InvitationListTab.vue?vue&type=style&index=0&id=b8f7936e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8f7936e"]])

export default __exports__